export const CTAS = {
  READ_MORE: 'READ_MORE',
  REQUEST_DEMO: 'REQUEST_DEMO',
  CHOOSE_DATES: 'CHOOSE_DATES',
  START_TRADING: 'START_TRADING',
  VIEW_PROGRESS: 'VIEW_PROGRESS',
  SIGN_UP: 'SIGN_UP',
  TRY_DEMO: 'TRY_DEMO',
  OPEN_LIVE_ACCOUNT: 'OPEN_LIVE_ACCOUNT',
};

export const SOLUTIONS = {
  ACCESS_AND_RETENTION: {
    TITLE: 'Access & Retention',
    LINK: '/access-and-retention',
  },
  BIG_DATA_ANALYTICS: {
    TITLE: 'Big Data & Analytics',
    LINK: '/big-data-analytics',
  },
  EFFICIENT_MARKETS: {
    TITLE: 'Efficient Markets',
    LINK: '/efficient-markets',
  },
};
